import React, { useRef, useEffect } from 'react';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';

/**
 * Select
 * Props:
 *   label    — string
 *   options  — [{ value, label }]
 *   value, onChange, error, disabled, placeholder
 */
const Select = ({
  label,
  options = [],
  error,
  placeholder,
  className = '',
  value,
  onChange,
  disabled,
  hint,
  ...rest
}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    const el = selectRef.current;
    if (!el) return;

    const handleChange = () => {
      if (onChange) {
        onChange({
          target: {
            value: el.value,
            name: rest.name,
          }
        });
      }
    };

    el.addEventListener('change', handleChange);
    return () => {
      el.removeEventListener('change', handleChange);
    };
  }, [onChange, rest.name]);

  // Sync value dynamically
  useEffect(() => {
    if (selectRef.current && selectRef.current.value !== value) {
      selectRef.current.value = value ?? '';
    }
  }, [value]);

  return (
    <div className={`form-group ${className}`} style={{ marginBottom: 'var(--sp-4)' }}>
      <md-outlined-select
        ref={selectRef}
        label={label}
        disabled={disabled || undefined}
        error={!!error || undefined}
        supporting-text={error || hint || ''}
        style={{ width: '100%' }}
      >
        {placeholder && (
          <md-select-option value="" disabled>
            <div slot="headline">{placeholder}</div>
          </md-select-option>
        )}
        {options.map((opt) => (
          <md-select-option
            key={opt.value}
            value={opt.value}
            disabled={opt.disabled || undefined}
          >
            <div slot="headline">{opt.label}</div>
          </md-select-option>
        ))}
      </md-outlined-select>
    </div>
  );
};

export default Select;
